export const convertException = (exc, t) => {
    var res = exc.toLowerCase().replaceAll('.', '').replaceAll('/', '').replaceAll("'", '').replaceAll('"', '').replaceAll(',', '').replaceAll(':', '').replaceAll('-', '').replaceAll(' ', '_');
    return res;
}